import { render, staticRenderFns } from "./DashboardFacility.vue?vue&type=template&id=5dfd4132&scoped=true"
import script from "./DashboardFacility.vue?vue&type=script&lang=js"
export * from "./DashboardFacility.vue?vue&type=script&lang=js"
import style0 from "./DashboardFacility.vue?vue&type=style&index=0&id=5dfd4132&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfd4132",
  null
  
)

export default component.exports